import { permissions as p } from '@/common/permissions'

export const tutorsCreatePermission = p.TUTORS_CREATE
export const athletesCreatePermission = p.ATHLETES_CREATE
